/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 05/06/2023.
 */
import React from 'react'
import { colors, colorsLaminat, colorsLinoleum } from '../../constant'
import { StaticImage } from 'gatsby-plugin-image'
import FadeUp from '../../animation/FadeUp'

const KitchenMaterial = () => {
  return (
    <div
      className="container-fluid pt-5 "
      style={{
        background:
          'linear-gradient(-180deg, rgba(240,240,240,1) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,0.5) 100%)',
      }}
    >
      <div className="container py-md-6 pt-1 pb-4">
        <div className="row mb-6" style={{}}>
          <div className="col-12 col-md-8">
            <p className="mb-md-2 mb-1 opacity-75">Detaljen i overfladen</p>
            <h3 className="fw-bold mb-4 ">
              Hos Hackk kan du vælge mellem fire forskellige overflader til dine fronter.
            </h3>
          </div>

          <div className="col-12 col-md-8">
            {/* <p className="mb-4">Hos Hackk kan du vælge mellem tre forskellige overflader til dine fronter.</p>*/}
            <p>
              Skal det være malet finish med over 2.200 farver at vælge imellem? Måske linoleum, der er blødt at røre
              ved og samtidig tåler hårdhændet behandling? Laminat i 20 forskellige farver der er nemt holde og rengøre?
              Eller håndolieret naturfinér, hvor træets årer får lov til at stråle?
            </p>
          </div>
        </div>

        <FadeUp className="row mb-6">
          <div className="col-12 rounded-3 mb-4 " style={{ background: '#F8E3D1' }}>
            <div className="row mt-6 mt-md-0" style={{}}>
              <div className="col-md-6 col-12 d-flex justify-content-center align-items-center">
                <div className="px-md-7 py-md-5 py-lg-0 px-5 mt-2">
                  <h3 className="mb-3 text-black fw-bold">Med natur-finish får du et helt klassisk snedkerkøkken.</h3>
                  <p className="text-black">
                    Med natur-finish får du et helt klassisk snedkerkøkken. Vi udvælger nøje årenes forløb i det
                    håndolierede finér, hvor over- og underskab altid er i naturlig forlængelse af hinanden. Når kun
                    komplet snedkerluksus er godt nok.
                  </p>

                  <p className="mt-2">
                    Vælg imellem <span className="fw-bold">Eg</span>, <span className="fw-bold">røget eg</span> og{' '}
                    <span className="fw-bold">Valnød</span>
                  </p>
                  {/*<div className="mt-4">
                    <Button style={{ width: 100 }} title="Se priser" className="px-3"></Button>
                  </div>*/}
                </div>
              </div>
              <div className="col-md-6 col-12 px-md-6 px-5 py-6 d-flex justify-content-center ">
                <StaticImage
                  style={{
                    background: '#F5F5F5',
                    '--bs-aspect-ratio': '120%',
                    boxShadow: '0px 5px 50px -2px rgba(0, 0, 0, 0.15)',
                  }}
                  className="ratio "
                  objectFit="cover"
                  src="../../images/kitchen-three.png"
                  objectPosition="0% 0%"
                  alt="kitchen "
                  quality={100}
                ></StaticImage>
              </div>
            </div>
          </div>
        </FadeUp>

        <FadeUp className="row mb-0 mb-md-6 mb-6">
          <div className="col-12 mb-md-5 rounded-3" style={{ background: '#B9D1E0' }}>
            <div className="row" style={{}}>
              <div className="col-md-6 col-12 px-md-6 px-5 py-md-6 py-5 d-flex justify-content-center ">
                <StaticImage
                  style={{
                    '--bs-aspect-ratio': '120%',
                    boxShadow: '0px 4px 50px -2px rgba(0, 0, 0, 0.22)',
                  }}
                  className="ratio "
                  objectFit="cover"
                  src="../../images/material_linoleum_big.png"
                  objectPosition="0% 70%"
                  alt="kitchen "
                  quality={100}
                ></StaticImage>
              </div>
              <div className="col-md-6 col-12 d-flex justify-content-center align-items-center px-0">
                <div className="ps-md-4 pe-md-6 px-5 mt-3 pb-5">
                  <h3 className="mb-3 text-black fw-bold">Med linoleum får du en blød og solid overflade</h3>
                  <p className="text-black">
                    Overfladen er rar at røre ved og giver god akustik. Det er et supermat organisk materiale, som
                    skjuler fedtfingre og er ekstremt holdbart.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 mt-1 mt-md-3 mb-md-6">
            <p className="mt-4 mb-2 opacity-75">Se vores udvalg af</p>
            <h4 className="mb-3 text-black fw-semibold">Linoleums farver</h4>
            <div className="d-flex mt-4 justify-content-between flex-wrap ">
              {colorsLinoleum.map((color, index) => {
                return (
                  <div key={index} className="align-items-center  mt-2 me-4" style={{ width: 140 }}>
                    <div
                      style={{
                        background: color.color,
                        width: 140,
                        height: 140,
                        borderRadius: 4,
                        boxShadow: '0px 5px 50px -2px rgba(0, 0, 0, 0.15)',
                      }}
                    ></div>
                    <p className="mt-1 p-small">{color.title}</p>
                  </div>
                )
              })}

              {/*

              To get everything to align i have added a axtra color block
              ---------------------------------------------------
              */}
              <div className="align-items-center d-none d-md-block mt-2 me-4" style={{ width: 140 }}>
                <div
                  style={{
                    background: 'none',
                    width: 140,
                    height: 140,
                    borderRadius: 4,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </FadeUp>

        <FadeUp className="row ">
          <div className="col-12 mb-4 rounded-2 " style={{ background: '#EFECE1' }}>
            <div className="row" style={{}}>
              <div className="col-md-6 col-12 px-md-6 px-5 py-md-6 py-5 d-flex justify-content-center ">
                <StaticImage
                  style={{
                    '--bs-aspect-ratio': '125%',
                    boxShadow: '0px 4px 50px -2px rgba(0, 0, 0, 0.1)',
                  }}
                  className="ratio "
                  objectFit="cover"
                  src="../../images/material_painted.png"
                  objectPosition="50% 50%"
                  alt="kitchen "
                  quality={100}
                ></StaticImage>
              </div>
              <div className="col-md-6 col-12 d-flex justify-content-center align-items-center px-0">
                <div className="ps-md-4 pe-md-6 px-5 mt-3 pb-5">
                  <h3 className="mb-3 text-black fw-bold">
                    Malede overflader, <br /> et hav muiligheder.
                  </h3>
                  <p className="text-black">
                    Her kan du vælge alle farver indenfor NCS - 1950 classic & Ral Classic farve systemerne. Hvilket
                    giver dig over 2200 muligheder. Malede fronter er vores mest prisvenlige valg.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 mt-4">
            <p className=" mb-1 opacity-75">Vi tilbyder over 2200 farver</p>
            <h4 className="mb-3 text-black fw-semibold">Her et udvalg af malet farver</h4>
            <div className="d-flex mt-4 justify-content-between flex-wrap pb-6">
              {colors.map((color, index) => {
                return (
                  <div key={index} className="align-items-center  mt-2 me-4" style={{ width: 140 }}>
                    <div
                      style={{
                        background: color.color,
                        width: 140,
                        height: 140,
                        borderRadius: 4,
                      }}
                    ></div>
                    <p className="mt-1 p-small">{color.title}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </FadeUp>

        <FadeUp className="row ">
          <div className="col-12 mb-4 rounded-2 " style={{ background: '#dad1ce' }}>
            <div className="row" style={{}}>
              <div className="col-md-6 col-12 px-md-6 px-5 py-md-6 py-5 d-flex justify-content-center ">
                <StaticImage
                  style={{
                    '--bs-aspect-ratio': '125%',
                    boxShadow: '0px 4px 50px -2px rgba(0, 0, 0, 0.1)',
                  }}
                  className="ratio "
                  objectFit="cover"
                  src="../../images/material_laminat.png"
                  objectPosition="50% 50%"
                  alt="kitchen "
                  quality={100}
                ></StaticImage>
              </div>
              <div className="col-md-6 col-12 d-flex justify-content-center align-items-center px-0">
                <div className="ps-md-4 pe-md-6 px-5 mt-3 pb-5">
                  <h3 className="mb-3 text-black fw-bold">Med Laminat får du en silkemat finish</h3>
                  <p className="text-black">
                    Med Laminat fra serien RAUVISIO noir får du en silkemat finish som gør overfladerne levende og
                    skaber den perfekte balance mellem design og funktion. Fordele ved laminat, overfladen er let at
                    rengøre & antibakteriel, er modstandsdygtig over almindelige og mikroskopiske ridser, har en lav
                    lysreflektion, anti-fingeraftryk & soft touch. Fronterne er perfekte til hverdagslivet med børn.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 mt-4">
            {/*<p className=" mb-1 opacity-75">Vi tilbyder over 2200 farver</p>*/}
            <h4 className="mb-3 text-black fw-semibold">Her et udvalg af Laminat farver</h4>
            <div className="d-flex mt-4 flex-wrap pb-6">
              {colorsLaminat.map((color, index) => {
                return (
                  <div key={index} className="align-items-center  mt-2 me-4" style={{ width: 140 }}>
                    <div
                      style={{
                        background: color.color,
                        width: 140,
                        height: 140,
                        borderRadius: 4,
                      }}
                    ></div>
                    <p className="mt-1 p-small">{color.title}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </FadeUp>

        {/*  <div className="row mt-5" style={{}}>
          <div className="col-12 col-md-4 mb-5">
            <StaticImage
              style={{}}
              className="ratio ratio-1x1 mx-2 "
              objectFit="cover"
              src="../../images/material_veneer.png"
              objectPosition="0% 0%"
              alt="material veener "
              quality={100}
            ></StaticImage>

            <div className="py-3 px-2 mt-2">
              <p className="mb-3">
                <span className="fw-bold text-black">Natur</span>
              </p>
              <p className="">{VENEER_TEXT}</p>
            </div>
          </div>

          <div className="col-12 col-md-4 mb-5">
            <StaticImage
              style={{}}
              className="ratio ratio-1x1 mx-2 "
              objectFit="cover"
              src="../../images/material_linoleum.png"
              objectPosition="0% 0%"
              alt="material veener "
              quality={100}
            ></StaticImage>
            <div className="py-3 px-2 mt-2">
              <p className="mb-3">
                <span className="fw-bold text-black">Linoleum</span>
              </p>
              <p className="">
                Med linoleum får du en blød og solid overflade, der er rar at røre ved og giver god akustik. Det er et
                supermat organisk materiale, som skjuler fedtfingre og er ekstremt holdbart.
              </p>
            </div>
          </div>

          <div className="col-12 col-md-4 mb-5">
            <StaticImage
              style={{}}
              className="ratio ratio-1x1 mx-2 "
              objectFit="cover"
              src="../../images/material_paint.png"
              objectPosition="0% 0%"
              alt="material veener "
              quality={100}
            ></StaticImage>
            <div className="py-3 px-2 mt-2">
              <p className="mb-3">
                <span className="fw-bold text-black">Malede finish </span>
              </p>
              <p className="">
                Har du øje for detaljen og er kræsen med nuancerne? Vi har 2.200 farver at vælge imellem, så du aldrig
                skal gå på kompromis. Se dit køkken i farver:
              </p>
            </div>
          </div>
        </div>*/}
      </div>
    </div>
  )
}
export default KitchenMaterial
